import React from "react";
import { Modal, Row, Col } from "react-bootstrap";
import _renderAddress from "./_renderAddress";

class _selectAddress extends React.Component {
    render() {
        return (
            <Modal
                show={this.props.open}
                onHide={() => this.props.onHide()}
                centered
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className="h5">{this.props.addresstype == "F" ? "Vybrat fakturační adresu" : "Vybrat dodací adresu"}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.props.user.detail[0]._address != null && (
                        <>
                            {this.props.user.detail[0]._address.filter(e => e.type == this.props.addresstype).map((e, idx) => (
                                <div onClick={() => this.props.select(e,idx)} className="cursor-pointer">
                                    <_renderAddress e={e} idx={idx} />
                                </div>
                            ))}</>
                    )}
                </Modal.Body>
            </Modal>
        )
    }
}

export default _selectAddress;